export default __webpack_public_path__ + "locales/el-GR/Files.json?hash=1cd8a4dcf3091c2a7ea3eede73e830d2";